module.exports = __webpack_public_path__ + "ru.4336677b.svg";